import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { JobDetailsOverviewPage } from './job-details-overview.page';

const routes: Routes = [
  {
    path: '',
    component: JobDetailsOverviewPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobDetailsOverviewPageRoutingModule {}
